import { Modal } from "antd";
import { toast } from "react-hot-toast";
import i18n from '../i18n';
import { Bugsnag } from '../bugsnag';

export const getErrorMessage = (error) => {
    if (typeof error === 'string') {
        return error;
    } else if (error?.response?.data?.error) {
        return error.response.data.error;
    } else if (error?.response?.data?.errors) {
        return error.response.data.errors;
    } else if (error?.error) {
        return error.error;
    } else if (error?.message) {
        return error.message;
    }
    return null;
};

export const handleError = (error) => {
    if (error?.isNetworkError) {
        toast.error(i18n.t('common.errors.network'));
        return;
    }

    // Don't report non-errors
    if (!error) return;

    // Report to Bugsnag
    Bugsnag.notify(error);

    const message = getErrorMessage(error);

    if (message) {
        console.error(message);
        toast.error(message);
    } else {
        console.warn('Unknown error format:', error);
    }
}

export const handleWarning = (message) => {
    if (message) {
        toast(message, {
            icon: '❗',
        });
        console.warn(message);
    }
}

export const displayWarningModal = (title, body, elemId = 'warning-modal') => {
    Modal.warn({
        title,
        content: <div data-testid={elemId}>{body}</div>,
    });
    console.error(title, body);
};
